/**
 * mobile-drawer-app-bar.js
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import AppBar from 'components/app-bar';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';


export default function MobileDrawerAppBar({ 
  title, 
  onClose, 
  saveButton, 
  hideMenu, 
  items,
  basePath 
}) {

  const onCloseDrawer = () => {
    if (onClose) {
      onClose();
    }
  }


  return (
    <AppBar
      title={title}
      leftActions={
        <IconButton
          data-testid="mobile-drawer-close-button"
          onClick={onCloseDrawer}
          size="small"
          style={{ color: 'inherit' }}
        >
          <Icon type='close' />
        </IconButton>}
      rightActions={(
        <>
          {saveButton}

          {!hideMenu && items &&
          <DropMenu
            id={`mobile-appbar-menu`}
            aria-label="menu options"
            label={
              <IconButton
                size="small"
                style={{ color: 'inherit' }}
              >
                <Icon type='menu' />
              </IconButton>}
            items={items.map(({ key, iconName, label, path }) => ({
              key,
              name: label,
              icon: iconName,
              component: Link,
              to: `${basePath}${path}`
            }))}
          />}
        </>
      )}
    />
  );
};